export default "__VITE_ASSET__D1SbxT$f__"